import React from 'react';


const ICEBasicInfoCard = ({ infoDetails }) => {
    return (
        <div className="basic-info-card profile-section-box">
            {infoDetails?.map(({ heading, subheading, isIconHeader }, index) => (
                <div className="basic-info-card-item" key={`basic_info_${heading}_${index}`}>
                    {heading && <h3 className="heading">{heading}</h3>}
                    {subheading && <div className={`subheading ${(isIconHeader) ? 'icon-header' : ''}`}>{subheading}</div>}
                </div>
            ))}
        </div>
    )
}


export default ICEBasicInfoCard;